import React from "react";
import DataFreshness from "./DataFreshness";

/* The element a page can render its own controls into, beside its title --
   Financial Statements puts its statement tabs there, with createPortal.
   Empty it takes no room: App.css hides it until something is in it, so a
   page that puts nothing there leaves the bar as it always was. */
export const VIEW_HEADER_SLOT_ID = "fox-view-header-slot";

/**
 * BackBar - view sub-header replacing the old dark blue bar.
 *
 * Props:
 *   title      {string}    - dashboard name shown on left
 *   children               - filter controls (pills, selects)
 *   rightSlot  {ReactNode} - optional right-side controls
 *                            (refresh button, etc.)
 *   freshness  {object}    - /api/data-freshness payload for this page.
 *                            Renders the "Updated ... · N sources" stamp with
 *                            its per-source popover. Falsy renders nothing.
 */
export default function BackBar({ title, children, rightSlot, freshness }) {
  return (
    <div className="fox-view-header">
      <div className="fox-view-header-left">
        <span className="fox-view-title">{title}</span>
        <DataFreshness freshness={freshness} />
        {children && <span className="fox-view-sep" />}
        {children && <div className="fox-view-filters">{children}</div>}
        <div id={VIEW_HEADER_SLOT_ID} className="fox-view-slot" data-testid="fox-view-slot" />
      </div>
      {rightSlot && <div className="fox-view-header-right">{rightSlot}</div>}
    </div>
  );
}
